import React from 'react';
import { ICalendarType } from '../../Calendar';
import { getAriaDayNavigationBtn } from '../../helpers/ariaComposers';
import { decrementDateByDays, incrementDateByDays, today } from '../../helpers/dateFormatters';
import { ICalendarPosition } from '../CalendarView';
require("./NamedDaysAddon.css");
var styles = {
  "Root": "NamedDaysAddon-module-Root_1od",
  "DayNavigationButton": "NamedDaysAddon-module-DayNavigationButton_2cW"
};
export const NamedDaysAddon = ({
  calendarType,
  calendarPosition,
  onClickDate
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.Root
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": getAriaDayNavigationBtn({
      calendarType,
      calendarPosition,
      navBtnType: 'yesterday'
    }),
    className: styles.DayNavigationButton,
    value: JSON.stringify({
      ...decrementDateByDays(today, 1),
      calendarPosition
    }),
    onClick: onClickDate
  }, "\u0412\u0447\u0435\u0440\u0430"), /*#__PURE__*/React.createElement("button", {
    "aria-label": getAriaDayNavigationBtn({
      calendarType,
      calendarPosition,
      navBtnType: 'today'
    }),
    className: styles.DayNavigationButton,
    value: JSON.stringify({
      ...today,
      calendarPosition
    }),
    onClick: onClickDate
  }, "\u0421\u0435\u0433\u043E\u0434\u043D\u044F"), /*#__PURE__*/React.createElement("button", {
    "aria-label": getAriaDayNavigationBtn({
      calendarType,
      calendarPosition,
      navBtnType: 'tomorrow'
    }),
    className: styles.DayNavigationButton,
    value: JSON.stringify({
      ...incrementDateByDays(today, 1),
      calendarPosition
    }),
    onClick: onClickDate
  }, "\u0417\u0430\u0432\u0442\u0440\u0430"));
};